import React from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';
import { Wallet } from 'lucide-react';

/**
 * Reusable Wallet Connect Button
 * Shows connect button when disconnected, wallet info when connected
 */
export const WalletConnectButton = ({ className = '' }) => {
  const { isConnected } = useAccount();
  
  return (
    <div className={`flex justify-center ${className}`}>
      <ConnectButton.Custom>
        {({ account, chain, openConnectModal, openAccountModal, mounted }) => {
          const connected = mounted && account && chain;
          
          return (
            <button
              onClick={connected ? openAccountModal : openConnectModal}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontFamily: "'Nunito', sans-serif",
                padding: '12px 24px',
                borderRadius: '12px',
                fontSize: '14px',
                fontWeight: 500,
                backgroundColor: connected ? 'rgba(0,0,0,0.05)' : '#f3ce0d',
                color: '#1d1d22',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 150ms',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = connected ? 'rgba(0,0,0,0.1)' : '#e2bf00';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = connected ? 'rgba(0,0,0,0.05)' : '#f3ce0d';
              }}
            >
              <Wallet style={{ width: '18px', height: '18px' }} />
              {connected ? account.displayName : 'Connect Wallet'}
            </button>
          );
        }}
      </ConnectButton.Custom>
    </div>
  );
};

/**
 * Wallet Connect Section - shows button + optional message
 */
export const WalletConnectSection = ({ message, className = '' }) => {
  const { isConnected, address } = useAccount();
  
  if (isConnected) {
    return (
      <div className={`text-center ${className}`}>
        <div 
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 20px',
            backgroundColor: 'rgba(0,0,0,0.05)',
            borderRadius: '12px',
            fontFamily: "'Nunito', sans-serif",
            fontSize: '14px',
            fontWeight: 500,
            color: '#1d1d22',
          }}
        >
          <div 
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#22c55e',
            }}
          />
          {address?.slice(0, 6)}...{address?.slice(-4)}
        </div>
      </div>
    );
  }
  
  return (
    <div className={`text-center ${className}`}>
      {message && (
        <p style={{ 
          fontFamily: "'Nunito', sans-serif",
          fontSize: '14px',
          color: '#52525b',
          marginBottom: '12px',
        }}>
          {message}
        </p>
      )}
      <WalletConnectButton />
    </div>
  );
};
